
    import { Component, Inject, Vue } from 'vue-property-decorator'
    import validation from "@/app/common/helpers/validation"
    import { VForm } from "@/app/common/types/v-form.type"
    import { NotificationDispatcher } from "@/app/common/services/notification-dispatcher.service"
    import { NpsStep } from "@/app/nps-feedback/support/nps-step"
    import { NpsSubmitScoreCommand } from "@/app/nps-feedback/commands/nps-submit-score.command"
    import { NpsSubmitFollowUpCommand } from "@/app/nps-feedback/commands/nps-submit-follow-up.command"
    import { NpsSubmitFreeAnswerCommand } from "@/app/nps-feedback/commands/nps-submit-free-answer.command"

    @Component({
        metaInfo() {
            return {
                title: 'Feedback'
            }
        }
    })
    export default class NpsFeedback extends Vue {
        loading = false
        step = NpsStep.Final
        rules = validation

        resultId?: string

        followUpQuestion?: string
        followUpAnswers: string[] = []
        followUpFreeAnswer?: string

        freeAnswerPrompt?: string
        freeAnswerText = '';

        @Inject() notificationDispatcher!: NotificationDispatcher
        @Inject() npsSubmitScoreCommand!: NpsSubmitScoreCommand
        @Inject() npsSubmitFollowUpCommand!: NpsSubmitFollowUpCommand
        @Inject() npsSubmitFreeAnswerCommand!: NpsSubmitFreeAnswerCommand

        async mounted() {
            const token = this.getToken()
            const score = this.getValue()

            if (token !== undefined && score !== undefined) {
                await this.submitScore(token, score)
            }
        }

        getOptions(): string[] {
            const options = []

            options.push(...this.followUpAnswers)

            if(this.followUpFreeAnswer !== undefined) {
                options.push(this.followUpFreeAnswer)
            }

            return options
        }

        getValue(): number|undefined {
            let value

            const query = this.$route.query.value
            if (typeof query === 'string') {
                value = parseInt(query)
            }

            return value
        }

        getToken(): string|undefined {
            let value

            const query = this.$route.query.token
            if (typeof query === 'string') {
                value = query
            }

            return value
        }

        get NpsStep() {
            return NpsStep
        }

        async submitScore(token: string, score: number) {
            try {
                this.loading = true

                const result = await this.npsSubmitScoreCommand.run(score, token)

                if (result.followUp !== undefined) {
                    this.resultId = result.resultId

                    this.followUpQuestion = result.followUp.question
                    this.followUpAnswers = result.followUp.alternatives
                    this.followUpFreeAnswer = result.followUp.freeAnswer

                    this.step = NpsStep.FollowUp
                }
            } catch (e) {
                this.step = NpsStep.Final
            } finally {
                this.loading = false
            }
        }

        async submitFollowUp(answer: any) {
            try {
                this.loading = true

                if (this.resultId !== undefined) {
                    const result = await this.npsSubmitFollowUpCommand.run(this.resultId, answer)

                    if (result.freeAnswerPrompt !== undefined) {
                        this.freeAnswerPrompt = result.freeAnswerPrompt

                        this.step = NpsStep.FreeAnswer
                    } else {
                        this.step = NpsStep.Final
                    }
                }
            } catch (e) {
                this.step = NpsStep.Final
            } finally {
                this.loading = false
            }
        }

        async submitFreeAnswer() {
            const form = this.$refs.freeAnswerForm as VForm
            if (!form.validate()) {
                await this.notificationDispatcher.error('vul alle velden in')
                return
            }

            try {
                this.loading = true

                if (this.resultId !== undefined) {
                    await this.npsSubmitFreeAnswerCommand.run(this.resultId, this.freeAnswerText)
                }

                this.step = NpsStep.Final
            } catch (e) {
                this.step = NpsStep.Final
            } finally {
                this.loading = false
            }
        }
    }
